import { makeStyles } from '@rbx/ui';
import { getCustomMarkdownFontSize } from '@modules/layout/layout/constants/layoutConstants';

const useMarkdownPStyles = makeStyles<{ enableEngineReferenceRevamp: boolean }>()(
  (theme, { enableEngineReferenceRevamp }) => ({
    root: {
      fontSize: getCustomMarkdownFontSize(enableEngineReferenceRevamp),
      color: theme.palette.text.secondary,
    },
  }),
);

export default useMarkdownPStyles;
